<script setup lang="ts">
import Button from "../atoms/Button.vue";

const open = defineModel<boolean>("open");
const emit = defineEmits<{
  (event: "confirm"): void;
  (event: "cancel"): void;
}>();

const handleConfirm = () => emit("confirm");
const handleCancel = () => emit("cancel");
</script>

<template>
  <UModal
    v-model:open="open"
    title="Confirm removal"
    close-icon="lucide:x"
    :ui="{
      content: 'rounded-[6px] shadow-none border border-on-primary-heading',
      close: 'cursor-pointer',
    }"
  >
    <template #body>
      <div class="flex flex-col gap-6">
        <p class="text-base text-on-primary-body">
          Your selection currently has only 6 items. If you remove this item,
          your selection will be unpublished.
        </p>
        <p class="text-sm text-on-primary-body opacity-80">
          Do you want to continue with removing this item from your selection?
        </p>
        <div class="flex items-center justify-end gap-3">
          <Button variant="secondary" @click="handleCancel"> Cancel </Button>
          <Button variant="primary" @click="handleConfirm"> Remove </Button>
        </div>
      </div>
    </template>
  </UModal>
</template>
